module.exports = __webpack_public_path__ + "static/media/All Falls Down.7a4966f1.txt";